export default {
	
	classic: [
		// [ '', '', '', '', '', '', '' ],
		[ '', '', 'E1', '', '', 'E2', 'E2' ],
		[ '', '', '', '', 'E3', '', 'T2' ],
		[ '', '', '', 'E3', '', '', 'T2' ],
		[ '', '', '', 'E3', 'T1', '', 'E2' ],
		[ '', '', '', 'T1', 'E3', '', 'E2' ],
		[ '', '', 'T1', 'T1', 'E1', '', 'E2' ],
		[ '', '', '', 'E1', 'T1', '', 'E2' ],
		[ '', '', '', 'E1', 'E1', '', 'T3' ],
		[ '', '', '', 'G1', 'E3', '', 'E1' ],
		[ '', 'G1', '', 'E1', 'T1', '', 'E3' ],
		[ '', 'I1', '', 'T3', '', '', 'E3' ],
		[ '', 'I2', '', 'T2', '', 'E3', '' ],
		[ '', '', 'I1', 'E1', '', '', 'T3' ],
		[ '', '', '', 'E1', '', '', 'E3' ],
		[ '', '', '', 'E3', 'T1', '', 'E1' ],
		[ '', '', 'T1', 'E1', '', '', 'E3' ],
		[ '', 'T1', '', 'E1', 'T1', '', 'E3' ],
		[ '', '', 'T2', 'E1', '', '', 'E3' ],
		[ '', '', '', 'E1', '', '', 'E3' ],
		[ '', '', 'T2', '', 'T2', '', 'E1' ],
		[ '', '', '', 'E1', 'E1', '', 'T2' ],
		[ '', '', '', 'E3', '', 'E3', 'I3' ],
		[ '', '', 'I1', 'E1', 'T1', '', 'E2' ],
	],

	boss: [
		// [ '', '', '', '', '', '', '' ],
		[ '', '', 'E1', '', '', 'E1', 'B2' ],
		[ '', '', '', '', 'E3', '', 'B2' ],
		[ '', '', '', 'E1', 'E1', '', 'B1' ],
		[ '', '', '', 'G1', 'E3', '', 'B1' ],
		[ '', 'G1', '', 'E1', '', '', 'B3' ],
		[ '', 'I1', '', 'E1', '', '', 'B3' ],
		[ '', '', 'I1', 'E1', '', '', 'B3' ],
		[ '', '', '', 'E1', '', 'G1', 'B3' ],
		[ '', '', '', '', '', 'I3', 'B3' ],
		[ '', 'T1', '', 'E1', '', '', 'B3' ],
		[ '', '', 'E1', 'T1', '', '', 'B3' ],
		[ '', '', 'T1', 'E1', '', '', 'B3' ],
		[ '', '', '', 'E1', '', 'T1', 'B3' ],
		[ '', '', '', 'E1', 'T1', '', 'B3' ],
		[ '', '', '', '', 'T2', '', 'B3' ],
	],

	tuto: [
		// [ '', '', '', '', '', '', '' ],
		[ '', '', '', 'E1', '', '', 'E2' ],
	]


}